//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        width:String,
        height:String,
        invert: Boolean
    },
    computed: {
        style() {
            var width = "";
            var height = "";

            if (this.width) {
                width = 'width:' + this.width + ' !important;';
            }

            if (this.height) {
                height = 'height:' + this.height + ' !important;';
            }

            return  width + height;
        }
    },
    data() {
        return {
            
        }
    }
}
